import Router from "@/common/router/Router";

export default class CustomerRouter extends Router {
  static entityName = "customer";
  static BASE_PATH = "/".concat(CustomerRouter.entityName);
  static SHOW_ROUTE_NAME = CustomerRouter.entityName.concat("-show");
  static CREATE_ROUTE_NAME = CustomerRouter.entityName.concat("-create");
  static UPDATE_ROUTE_NAME = CustomerRouter.entityName.concat("-update");
  static LIST_ROUTE_NAME = CustomerRouter.entityName.concat("-list");

  constructor() {
    super(
      CustomerRouter.BASE_PATH,
      CustomerRouter.SHOW_ROUTE_NAME,
      CustomerRouter.CREATE_ROUTE_NAME,
      CustomerRouter.UPDATE_ROUTE_NAME,
      CustomerRouter.LIST_ROUTE_NAME
    );
  }
}

export const customerRouter = new CustomerRouter();
